import { useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import debounce from "lodash.debounce";
import { acceptInvite } from "../services/authService";

export const AcceptInvite = () => {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const debouncedAcceptInvite = useCallback(
    debounce((token: string) => {
      acceptInvite(token).then((login_token) => {
        navigate(`/dashboard?t=${login_token}`);
      }).catch((error) => {
        console.error(error);

        const errorMessage = error.response.data.error;
        const status = errorMessage.includes("accepted") ? "accepted_invite" : "invalid_invite";

        navigate(`/login?status=${status}`);
      });
    }, 500), []);

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      navigate("/login?status=invalid_invite");
      return;
    }

    debouncedAcceptInvite(token);
  }, []);

  return <div>Loading...</div>;
}

export default AcceptInvite;
